import { create } from 'zustand';

export interface AudioContextStore {
    audioContext?: AudioContext;
    setAudioContext: (ctx: AudioContext) => void;
    resetAudioContext: () => void;
}

export const useAudioContextStore = create<AudioContextStore>((set) => ({
    audioContext: undefined,
    setAudioContext: (ctx) => set({ audioContext: ctx }),
    resetAudioContext: () => set({ audioContext: undefined }),
}));
